import { useMemo } from "react";
import DOMPurify from "dompurify";
import { USER_GUIDE_SECTIONS, USER_GUIDE_CONTENT } from '../userGuideV3';

// ═══════ Documentation Modal ═══════
export const DocumentationModal = ({
  showDocModal, setShowDocModal, docTitle, docContent, docLoading, renderMd,
}) => {
  const sanitizedGuide = useMemo(() => {
    if (docContent !== '__USER_GUIDE__') return null;
    return USER_GUIDE_SECTIONS.reduce((acc, s) => {
      acc[s.id] = DOMPurify.sanitize(USER_GUIDE_CONTENT[s.id]);
      return acc;
    }, {});
  }, [docContent]);

  const sanitizedDoc = useMemo(() => {
    if (!docContent || docContent === '__USER_GUIDE__') return '';
    return DOMPurify.sanitize(renderMd(docContent));
  }, [docContent, renderMd]);

  if (!showDocModal) return null;

  return (
    <div className="doc-modal-overlay">
      <div className="doc-modal">
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
          <h2 style={{fontSize:'18px',fontWeight:700}}>{docTitle}</h2>
          <button className="beige-btn" onClick={() => setShowDocModal(false)} style={{padding:'4px 10px'}}>
            <svg style={{width:'16px',height:'16px'}} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        {docLoading ? (
          <div style={{textAlign:'center',padding:'40px 0',color:'var(--text-muted)'}}>Loading...</div>
        ) : docContent === '__USER_GUIDE__' ? (
          <div style={{fontSize:'13px',lineHeight:1.6}} data-testid="user-guide-content">
            <nav style={{background:'#e8e5dc',borderRadius:'8px',padding:'16px 20px',marginBottom:'24px',border:'1px solid #d5d0c4'}}>
              <div style={{fontSize:'14px',fontWeight:700,marginBottom:'10px',color:'#4a4535',letterSpacing:'0.5px'}}>TABLE OF CONTENTS</div>
              {USER_GUIDE_SECTIONS.map(s => (
                <div key={s.id} style={{marginBottom:'4px'}}>
                  <a href={`#doc-${s.id}`} onClick={(e) => { e.preventDefault(); document.getElementById(`doc-${s.id}`)?.scrollIntoView({behavior:'smooth',block:'start'}); }}
                    style={{color:'#5a6a4a',textDecoration:'none',fontSize:'13px',display:'block',padding:'3px 0'}}
                    onMouseOver={e => e.target.style.textDecoration='underline'}
                    onMouseOut={e => e.target.style.textDecoration='none'}
                  >{s.num} &middot; {s.title}</a>
                </div>
              ))}
            </nav>
            {USER_GUIDE_SECTIONS.map(s => (
              <section key={s.id} id={`doc-${s.id}`} style={{marginBottom:'32px',scrollMarginTop:'20px'}}>
                <h2 style={{fontSize:'16px',fontWeight:700,color:'#3a3525',marginBottom:'12px',paddingBottom:'6px',borderBottom:'1px solid #d5d0c4'}}>
                  {s.num} &middot; {s.title}
                </h2>
                <div dangerouslySetInnerHTML={{__html: sanitizedGuide[s.id]}} />
              </section>
            ))}
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{__html: sanitizedDoc}} style={{fontSize:'13px',lineHeight:1.6}} />
        )}
      </div>
    </div>
  );
};
